import { render } from "./ConsultingTermsServiceModal.vue?vue&type=template&id=4e2d5612&scoped=true"
import script from "./ConsultingTermsServiceModal.vue?vue&type=script&lang=js"
export * from "./ConsultingTermsServiceModal.vue?vue&type=script&lang=js"

import "./ConsultingTermsServiceModal.vue?vue&type=style&index=0&id=4e2d5612&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2d5612"]])

export default __exports__